// export const BASE_URL="http://localhost:8000/api/v1/"
// export const BASE_URL="https://fs.ace-inventory.com/backend/api/v1/"
// export const BASE_URL="https://staging.ace-inventory.com/backend/api/v1/"
// export const BASE_URL="https://staging-dev.ace-inventory.com/backend/api/v1/"
export const BASE_URL="https://pms.ace-inventory.com/backend/api/v1/"
